import { matchPath } from "react-router";
import { SETTINGS_ROUTES } from "../../../../../consts/routes";

export const getPathParams = () => {
  const { params } = matchPath(window.location.pathname, {
    path: SETTINGS_ROUTES.smsSnippets.edit(":id"),
    exact: true,
    strict: false,
  });

  return {
    id: params.id ? Number(params.id) : undefined,
  };
};
